const state = {
    details: null,
    editMode: false,
    editDetails: null,
    webformContent: null, // Set as another property instead of using in details to prevent the webform to be updated to null when the details been updated on edit client webform
    isDirty: null
};

const getters = {
    webformContent: state => {
        return state.webformContent;
    },
    details: state => {
        return state.details;
    },
    editMode: state => {
        return state.editMode;
    },
    editDetails: state => {
        return state.editDetails;
    },
    isDirty: state => {
        return state.isDirty;
    }
};
const actions = {
    cancelEdit({ commit }) {
        commit("setEditMode", false);
        commit("setDirty", false);
        commit("setEditDetails", state.details);
    },
    async updateWebform({ commit, dispatch }, self) {
        const patientId = state.editDetails.patient
            ? state.editDetails.patient.id
            : null;
        const response = await dispatch("saveWebform", {
            webformId: state.editDetails.id,
            params: {
                patient_id: patientId,
                client_id: state.editDetails.client_id,
                template_id: state.editDetails.template_id,
                title: state.editDetails.title,
                update_at: Math.round(self._now().toSeconds())
            }
        });

        if (response) {
            commit("setEditMode", false);
            commit("setDirty", false);
            commit("setDetails", response);
            commit("setEditDetails", response);
        }

        return response;
    },
    async saveWebform({ commit }, { webformId, params }) {
        return await ClientWebformService.updateWebform(webformId, params);
    }
};
const mutations = {
    setDirty(state, isDirty) {
        state.isDirty = isDirty;
    },
    setWebformContent(state, webformContent) {
        // TODO : CHECK IN ONLINE WEBFORM, NEED TO SEND OBJECT
        if (isEmpty(webformContent)) {
            webformContent = null;
        } else if (typeof webformContent != "object") {
            webformContent = JSON.parse(webformContent);
        }

        state.webformContent = webformContent;
        if (state.details) {
            state.details.webform_content = webformContent;
        }
        if (state.editDetails) {
            state.editDetails.webform_content = webformContent;
        }
    },
    setDetails(state, details) {
        if (details) {
            // FOR CLIENT WEBFORM CHECK IF NOT SENT, STILL ACTIVE AND ISEDITABLE.STATUS = TRUE (THE CLINIC OWN THE CLIENT DATA, NOT SHARED)
            details.isEnableEdit =
                details.is_sent == WEBFORM_NOT_SENT &&
                details.isactive &&
                details.isEditable &&
                details.isEditable.status &&
                isEmpty(details.submitted_at);
        }

        state.details = details;
    },
    setEditMode(state, editMode) {
        state.editMode = editMode;
    },
    setEditDetails(state, editDetails) {
        state.editDetails = editDetails;
        if (state.editDetails) {
            state.editDetails.isTitleExceed = false;
        }
    }
};

import ClientWebformService from "@/services/client-webform";
import { isEmpty } from "lodash";
import AccountService from "@/services/account.js";

const WEBFORM_NOT_SENT = 0;

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
